import type { ServicePermissions } from '@/enums/ServicePermissions'
import type IPermissionChecker from '@/service/permissions/IPermissionChecker'
import { useUserStore } from '@/stores/UserStore'
import { injectable } from 'inversify'

@injectable()
export class PermissionChecker implements IPermissionChecker {
  public canShow(permissions: ServicePermissions[] | undefined): boolean {
    return this.hasPermission(permissions)
  }
  public canGo(permissions: ServicePermissions[] | undefined): boolean {
    return this.hasPermission(permissions)
  }

  public canEnable(permissions: ServicePermissions[] | undefined): boolean {
    return this.hasPermission(permissions)
  }

  private hasPermission(permissions: ServicePermissions[] | undefined): boolean {
    if (permissions && permissions.length > 0) {
      const userStore = useUserStore()
      const userPermissions = userStore.getPermissions
      return permissions?.some(perm => userPermissions?.includes(perm)) ?? false
    }
    return true
  }
}
